import React from 'react';

function Egypt(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124143)">
        <mask
          id="mask0_800_124143"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124143)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124143"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124143)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#BF2714"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#272727"
            />
            <path
              d="M13.7928 10.2202L14.9167 10.266L14.6346 15.7358L13.5107 15.69L13.7928 10.2202Z"
              fill="#C09302"
            />
            <path
              d="M14.9672 10.5597L16.0904 10.6161L15.8083 15.0515L14.6851 14.995L14.9672 10.5597Z"
              fill="#C09302"
            />
            <path
              d="M16.142 10.8918L17.2632 10.9736L16.9811 14.0296L15.8599 13.9479L16.142 10.8918Z"
              fill="#C09302"
            />
            <path
              d="M22.2072 10.2202L21.0833 10.266L21.3654 15.7358L22.4893 15.69L22.2072 10.2202Z"
              fill="#C09302"
            />
            <path
              d="M21.0328 10.5597L19.9096 10.6161L20.1917 15.0515L21.3149 14.995L21.0328 10.5597Z"
              fill="#C09302"
            />
            <path
              d="M19.858 10.8918L18.7368 10.9736L19.0189 14.0296L20.1401 13.9479L19.858 10.8918Z"
              fill="#C09302"
            />
            <path
              d="M17.9701 15.3267L16.8735 15.1034L17.3377 13.3027L18.4343 13.526L17.9701 15.3267Z"
              fill="#C09302"
            />
            <path
              d="M18.8097 15.3267L19.9062 15.1034L19.4421 13.3027L18.3455 13.526L18.8097 15.3267Z"
              fill="#C09302"
            />
            <path
              d="M18.5312 15.3102H17.4062V13.5422H18.5312V15.3102Z"
              fill="#C09302"
            />
            <path
              d="M16.4641 10.9133L17.5888 10.9378L17.5231 13.3187L16.3984 13.2942L16.4641 10.9133Z"
              fill="#C09302"
            />
            <path
              d="M18.4207 10.9133L19.5453 10.9378L19.4796 13.3187L18.355 13.2942L18.4207 10.9133Z"
              fill="#C09302"
            />
            <path
              d="M15.0049 15.9228L15.297 14.9572C16.4907 15.2425 17.4073 15.3836 18.0323 15.3836C18.6573 15.3836 19.5738 15.2425 20.7675 14.9572L21.0597 15.9228C19.779 16.229 18.7747 16.3836 18.0323 16.3836C17.2899 16.3836 16.2856 16.229 15.0049 15.9228Z"
              fill="#C09302"
            />
            <path
              d="M13.8174 10.2227C13.7424 9.56211 14.1774 9.11493 14.9146 9.17197C15.157 9.19072 15.4292 9.25446 15.7918 9.36381C15.8978 9.39612 15.8978 9.39612 16.0007 9.42852C16.4992 9.58612 16.6346 9.62663 16.6626 9.63196C16.5522 9.60973 16.8775 9.08696 16.9521 8.99884C16.961 9.0548 16.9235 9.04683 16.8336 9.03084L15.8188 8.85031L16.5412 8.19155C16.7937 7.96129 17.1299 7.84711 17.5136 7.84711C17.5534 7.84711 17.5905 7.84547 17.7124 7.8388C17.8026 7.83393 17.8026 7.83393 17.904 7.8302C18.6059 7.80998 19.1093 7.98642 19.1093 8.62808C19.1093 8.85763 19.1419 9.22678 19.1958 9.50683C19.2139 9.60104 19.2489 9.68922 19.1457 9.72795C19.15 9.69453 19.3958 9.60828 19.7781 9.46616L19.824 9.44911C20.9349 9.03696 21.0647 8.99873 21.4228 9.19217C21.6614 9.32108 21.8886 9.55295 22.1432 9.89867L21.202 10.4464C21.0377 10.2234 20.907 10.0881 20.8447 10.0503C20.9862 10.1377 20.5096 10.2784 20.2574 10.3719L20.2122 10.3887C19.3473 10.7102 19.2333 10.7486 18.986 10.7486C18.313 10.7486 18.0714 10.1358 18.0052 9.25829C17.7976 9.86586 17.1781 10.6326 16.6676 10.6326C16.4441 10.6326 16.5516 10.664 15.6237 10.3707C15.5265 10.3401 15.5265 10.3401 15.4304 10.3108C15.1493 10.226 14.9465 10.1785 14.8186 10.1683C14.8238 10.163 14.8427 10.1449 14.8638 10.1289L13.8174 10.2227Z"
              fill="#C09302"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124143">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Egypt;
